import { render, staticRenderFns } from "./LookUpName.vue?vue&type=template&id=046d453e&scoped=true&"
import script from "./LookUpName.vue?vue&type=script&lang=js&"
export * from "./LookUpName.vue?vue&type=script&lang=js&"
import style0 from "./LookUpName.vue?vue&type=style&index=0&id=046d453e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d453e",
  null
  
)

export default component.exports